module.exports = __webpack_public_path__ + "img/symbol_6.fe6f1538.png";